import { v4 as uuid } from "uuid";
import api from "./api";

const VID_KEY = "npc_vid";
const SID_KEY = "npc_sid";
export const CONSENT_KEY = "npc_analytics_consent";

function getVisitorId() {
    let v = localStorage.getItem(VID_KEY);
    if (!v) {
        v = uuid();
        localStorage.setItem(VID_KEY, v);
    }
    return v;
}

function getSessionId() {
    let s = sessionStorage.getItem(SID_KEY);
    if (!s) {
        s = uuid();
        sessionStorage.setItem(SID_KEY, s);
    }
    return s;
}

function send(type, path, target = "") {
    try {
        api.post("/track", {
            visitor_id: getVisitorId(),
            session_id: getSessionId(),
            path: path || window.location.pathname,
            referrer: document.referrer || "",
            type,
            target,
        }).catch(() => {});
    } catch (e) {
        /* no-op */
    }
}

export function trackBookClick(provider) {
    send("book_click", null, provider);
}

export function trackPageview(path) {
    send("pageview", path);
}

export function trackHeartbeat() {
    send("heartbeat");
}
